<template>
  <VContent>
    <VContainer fill-height>
      <VLayout
              style="{max-width:500px;}"
              align-content-center
              mx-auto
              wrap>
        <VFlex xs12 sm8 offset-sm2 md5 offset-md4>
          <BaseCard>
            <VCardTitle>
      <span class="title font-weight-light">
        Reset password
      </span>
            </VCardTitle>
            <VContainer>
              <VFlex xs12>

                <VTextField
                        v-model="username"
                        name="email"
                        label="Username or Email"
                        outlined
                />


                <VTextField
                        v-model="newPassword"
                        label="New Password"
                        name="newPassword"
                        outlined
                        autofocus
                        :append-icon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
                        :type="show ? 'text' : 'password'"
                        hint="At least 8 characters, must have a number and an uppercase letter"
                        counter
                        @click:append="show = !show"
                />

              </VFlex>
            </VContainer>
            <VCardActions>
              <BaseBtn  text
                    class="ma-0"
                    @click="requestReset()"
                    :loading="loading"
              >
                Reset
              </BaseBtn>
            </VCardActions>
          </BaseCard>
        </VFlex>
      </VLayout>
    </VContainer>
  </VContent>
</template>

<script>
    // Utilities

    import BaseBtn from "../../components/BaseBtn";
    import {
      mapActions,
      mapMutations
    } from 'vuex'

    export default {
      components: {BaseBtn},
      data () {
            const data = {
              verificationCode:false,
              newPassword:undefined,
              reseting:false,
              username:undefined,
              loading:false,
              show:false
            }
            return data
        },
        name: 'ResetPassword',

        mounted(){

        },
        methods: {
          ...mapActions('cognito', ['changePassword']),
          ...mapMutations(['setSnackbar']),
          requestReset(){
            let em = this;
            //set user
            this.changePassword({
              username:this.username,
              code:this.verificationCode,
              newPassword:this.newPassword
            }).then(res=>{
              em.$store.commit('setEmail',this.username)
              em.loading=false;
              em.$store.commit('setSnackbar',{
                type: 'info',
                msg: 'Password Reset',
                timeout:6000
              });
              em.$router.push('/auth/signin')
              em.reseting = true;
            }).catch(e=>{
              em.loading=false;
              em.$store.commit('setSnackbar',{
                type: res.status,
                msg: res.msg,
                timeout:6000
              })
            })
          }
        }
    }
</script>

